export const NotFoundPage = () => {
  return (
    <div className="flex justify-center items-center font-semibold text-5xl">
      404 NOT FOUND
    </div>
  );
};
